// extracted by mini-css-extract-plugin
export default {"menu-width":"18rem","button":"bAbJQ","toggleable":"t0GmQ","sideMenuWrapper":"Jv_VX","open":"lnE9c","sideMenu":"tVk5B","backdrop":"zrvkO","closed":"SrUa3"};